import * as React from 'react'

import DailyBodyHeader from './DailyBodyHeader'
import HourlyBodyHeader from './HourlyBodyHeader'

interface Props {
  isDaily: boolean
  showHourBalance: boolean
}

const BodyHeader = ({ isDaily, showHourBalance }: Props) => {
  if (isDaily) {
    return <DailyBodyHeader />
  }

  return <HourlyBodyHeader showHourBalance={showHourBalance} isDaily={isDaily} />
}

export default BodyHeader
